export default function HomePage(){

    return(

        <div className="text-center mt-5 ">
            <h1>Welcome Page</h1>
            <p>This is a test page.</p>
            <p>For test out different features!</p>
        </div>);
} 